const changeUserLanguage = require('../../../../../../src/frontend/old/groupon_modules/changeUserLanguage');
const {
  matchMQ,
} = require('../../../../../../src/frontend/helper/mediaQueries/mediaQueries');

const mediaQuery = Groupon.LS.mediaQueries.slsLMax;

module.exports = class ResponsiveMenu {
  constructor() {
    this.initialize = this.initialize.bind(this);
    this.constructUserNavigation = this.constructUserNavigation.bind(this);
    this.constructUserMenu = this.constructUserMenu.bind(this);
    this.constructLanguageMenu = this.constructLanguageMenu.bind(this);
    this.alterDOM = this.alterDOM.bind(this);
    this.unbind = this.unbind.bind(this);
    this.bind = this.bind.bind(this);
    this.getVisibility = this.getVisibility.bind(this);
    this.$menu = $('#ls-resp-menu');

    const mqCallback = () => this.initialize();

    if (matchMQ(mediaQuery)) {
      this.initialize();
    } else {
      window.matchMedia(mediaQuery).addListener(mqCallback);
    }
  }

  initialize() {
    if (this.$menu.children().length) {
      return;
    }
    this.$body = $('body');
    this.$overlay = $('#ls-resp-overlay');
    this.$searchBar = $('#ls-search-form');
    this.$userMenu = $('#ls-my-stuff');
    this.$responsiveMenuWrapper = $('#ls-resp-menu-wrapper');
    this.popoverActiveClass = 'responsive-show-500';
    this.popoverTriggerActiveClass = 'ls-resp-active';

    this.$menuTrigger = $('#ls-resp-menu-trigger');
    this.$searchTrigger = $('#ls-resp-search-trigger');
    this.$backButton = $('#ls-resp-back-button');

    this.unbind();
    this.$subnavs = this.constructSubNavFlyouts();
    const $primaryNav = this.constructPrimaryNavigation(this.$subnavs);
    const $userNav = this.constructUserNavigation(
      this.constructUserMenu(),
      this.constructLanguageMenu()
    );
    this.$menu.append($primaryNav, $userNav);
    this.dedupIDs();
    this.alterDOM();
    this.bind();

    $('#ls-resp-menu-wrapper').on('click', '#ls-resp-sign-out', () => {
      sessionStorage.removeItem('verifiedUser');
    });
  }

  constructPrimaryNavigation(subNavs) {
    let $primaryNav = $('.primary-nav > li')
      .clone()
      .attr({
        role: 'menuitem',
        style: null,
        class: 'ls-resp-menu-item',
      })
      .each(function() {
        // connect subnav to primary nav item
        const id = `subnav-${this.id}`;
        for (const subnav of Array.from(subNavs)) {
          if (subnav.id === id && subnav.children.length) {
            subnav.id = `ls-resp-${this.id.replace('-tab', '-menu')}`; // make id unique
            // remove aria attributes
            $(subnav).attr({
              'aria-labelled': null,
              'aria-labelledby': null,
              'aria-hidden': null,
            });
            const $this = $(this);
            // remove id, which got cloned
            // remove aria attributes - we have a logical markup representing
            // link/tab -> menu relationship
            $this.children('a').attr({
              id: null,
              role: null,
              tabindex: null,
              'aria-haspopup': null,
              'aria-owns': null,
            });
            // set caret + append subnav
            $this.addClass('icon-arrow-down-large').append(subnav);
          }
        }
        return (this.id = `ls-resp-${this.id.replace('-tab', '-trigger')}`);
      });
    $primaryNav.find('.icon-home').removeClass();

    $primaryNav = $primaryNav.map(function() {
      const $this = $(this);
      const $subnav = $this.find('.ls-resp-submenu');
      if (!$subnav.find('a').length) {
        $subnav.remove();
        $this.removeClass('icon-arrow-down-large');
      }
      return this;
    });

    return $primaryNav;
  }

  constructSubNavFlyouts() {
    const $subNavs = $('.subnav-flyout')
      .clone()
      .attr({
        'aria-hidden': 'true',
        role: 'menu',
        class: 'ls-resp-submenu hide',
        style: null,
      });
    $subNavs.each((i, flyout) => {
      const $flyout = $(flyout);
      const $links = $flyout.find('.subnav-categories > a, .flyMenu > li > a');
      $links.each((n, link) => $(link).attr({ class: 'ls-resp-subnav-link' }));
      return $flyout.html($links);
    });
    return $subNavs;
  }

  constructUserNavigation($userMenu, $langMenu) {
    let $cart, $userName;
    let $userNav = $('.ls-user-item, .user-menu-item')
      .not('.lang-menu')
      .clone()
      .wrap('<li class="ls-resp-menu-item"></li>')
      .parent();

    //lang selector & menu
    if ($langMenu.length) {
      $userNav = $langMenu.add($userNav);
    }

    // logged in user
    if (($userName = $userNav.find('.user-name')).length) {
      $userName
        .attr({
          href: null,
          id: 'ls-resp-user-name',
          class: 'icon-user',
          role: null,
          tabindex: null,
          'aria-haspopup': null,
          'aria-owns': null,
          'aria-describedby': null,
        })
        .text($userName.attr('data-user-name'))
        .parent()
        .attr({
          id: 'subnav-usermenu-menu',
          class:
            'ls-resp-menu-item ls-resp-menu-item-user icon-arrow-down-large',
        })
        .append($userMenu);
      const $signOut = this.$userMenu
        .find('#sign-out')
        .clone()
        .attr({
          class: null,
        })
        .wrap('<li class="ls-resp-menu-item"></li>')
        .parent();
      $userNav = $userNav.add($signOut);
    }

    // cart
    if (($cart = $userNav.find('.cart-widget')).length) {
      $cart = $cart.find('a');
      $userNav.find('.cart-widget').replaceWith($cart);
    }

    $userNav.find('.user-menu-item').removeClass();
    $userNav.eq(0).addClass('ls-resp-menu-divider');

    return $userNav;
  }

  constructUserMenu() {
    let $userMenu = {};
    if (this.$userMenu.length) {
      $userMenu = this.$userMenu.clone().attr({
        class: 'ls-resp-submenu hide',
        id: 'ls-resp-user-menu',
        role: 'menu',
        'aria-labelled': null,
        'aria-labelledby': null,
        'aria-hidden': null,
      });

      $userMenu.find('#sign-out').remove();
      $userMenu.find('svg').remove();
      $userMenu
        .find('a')
        .addClass('ls-resp-submenu-item')
        .each((i, link) => {
          const { id } = link;
          return $(link).attr({
            id: `ls-resp-${id}`,
            class: 'ls-resp-subnav-link',
          });
        });
      this.$subnavs = this.$subnavs.add($userMenu);
    }
    return $userMenu;
  }

  constructLanguageMenu() {
    let $langMenuSelector = {};
    if ($('.lang-menu').length) {
      $langMenuSelector = $('<span />')
        .text(
          $('#ls-lang-selected')
            .text()
            .trim()
        )
        .wrap('<li></li>')
        .parent()
        .attr({
          id: 'ls-resp-lang-trigger',
          class: 'ls-resp-menu-item ls-resp-lang-trigger icon-arrow-down-large',
        });

      const $langMenu = $('#ls-lang-list')
        .clone()
        .attr({
          id: 'ls-resp-lang-menu',
          class: 'ls-resp-submenu hide',
          role: 'menu',
          'aria-labelled': null,
          'aria-labelledby': null,
          'aria-hidden': null,
        })
        .off('mouseenter mouseleave');
      $langMenu
        .find('a')
        .addClass('ls-resp-subnav-link')
        .on('click', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          const language = $(this).data('locale');
          return changeUserLanguage(language);
        });
      $langMenuSelector.append($langMenu);
      // add menu to subnav list
      this.$subnavs = this.$subnavs.add($langMenu);
    }

    return $langMenuSelector;
  }

  // the new #ls-resp-menu-wrapper has a lot of duplicated id:s now; uniquify all
  dedupIDs() {
    return this.$responsiveMenuWrapper.find('*[id]').each(function() {
      if (!this.id.match(/ls-resp-/)) {
        this.id = `ls-resp-${this.id}`;
      }
    });
  }

  alterDOM() {
    $('.header').prepend([
      this.$menuTrigger,
      this.$backButton,
      this.$searchTrigger,
    ]);
    $('.header-v2').after(this.$overlay);

    return this.$body.prepend(this.$responsiveMenuWrapper);
  }

  unbind() {
    this.$searchTrigger.off('tap');
    this.$menuTrigger.off('tap');
    this.$overlay.off('tap');
    $('.ls-resp-submenu')
      .parent('li')
      .off('tap');
    $('.ls-resp-submenu a').off('tap');
    return this.$menu.empty();
  }

  bind() {
    this.$searchTrigger.on('tap', e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      const { menuVisible } = this.getVisibility();
      if (menuVisible) {
        this.hideRespMenu();
      } else {
        this.toggleOverlay();
        this.$body.toggleClass('noscroll');
      }
      this.$overlay.addClass('ls-resp-overlay-search-v3');
      this.$searchTrigger.toggleClass(this.popoverTriggerActiveClass);
      this.$searchBar.toggleClass(this.popoverActiveClass);
      return $('#ls-search').focus();
    });

    this.$menuTrigger.on('tap', e => {
      e.stopImmediatePropagation();
      const { searchVisible } = this.getVisibility();
      if (searchVisible) {
        this.hideRespSearch();
      } else {
        this.toggleOverlay();
        this.$body.toggleClass('noscroll');
      }
      this.$body.toggleClass('show-responsive-menu');
      this.$overlay.removeClass('ls-resp-overlay-search-v3');
      this.$menuTrigger.toggleClass(this.popoverTriggerActiveClass);
      return this.toggleAriaHidden(this.$responsiveMenuWrapper);
    });

    this.$overlay.on('tap', e => {
      e.preventDefault();
      this.hideRespSearch();
      this.hideRespMenu();
      return this.hideOverlay();
    });

    const $navWithMenu = $('.ls-resp-submenu').parent('li');
    $navWithMenu.on('tap', e => {
      const $tab = $(e.currentTarget);
      // get open subnavs and hide it
      return setTimeout(() => {
        const $visibleSubnavs = this.$subnavs.not('.hide').addClass('hide');
        $navWithMenu.removeClass('ls-resp-open-menu');

        return setTimeout(() => {
          const $flyout = $tab.children('.ls-resp-submenu');
          // test if menu exist and if this menu wasn't open before this event
          if ($flyout.length && !$flyout.is($visibleSubnavs)) {
            $tab.addClass('ls-resp-open-menu');
            $flyout.removeClass('hide');
          }
        }, 150);
      }, 150);
    });

    return $('.ls-resp-submenu a').on('tap', e => e.stopImmediatePropagation());
  }

  toggleAriaHidden($el) {
    let ariaHidden = $el.attr('aria-hidden');
    ariaHidden = ariaHidden === 'true' ? 'false' : 'true';
    return $el.attr('aria-hidden', ariaHidden);
  }

  getAttributes(elements, attribute) {
    const attributeArray = [];
    for (const el of Array.from(elements)) {
      attributeArray.push(
        $(el)
          .attr(attribute)
          .parent('li')
          .removeClass('ls-resp-open-menu')
      );
    }
    return attributeArray;
  }

  getVisibility() {
    return {
      searchVisible: this.$searchBar.is(':visible'),
      menuVisible: this.$responsiveMenuWrapper.is(':visible'),
    };
  }

  hideRespSearch() {
    if (this.$searchBar.is(':visible')) {
      this.$searchTrigger.removeClass(this.popoverTriggerActiveClass);
      this.$searchBar.removeClass(this.popoverActiveClass);
    }
  }
  hideRespMenu() {
    this.$body.removeClass('show-responsive-menu');
    return this.$menuTrigger.removeClass(this.popoverTriggerActiveClass);
  }
  hideOverlay() {
    this.$overlay.hide();
    return this.$body.removeClass('noscroll');
  }
  toggleOverlay() {
    return this.$overlay.toggle();
  }

  // remove aria attributes
  removeAria(menu) {
    return $(menu).attr({
      'aria-labelled': null,
      'aria-labelledby': null,
      'aria-hidden': null,
    });
  }
};
